import PropTypes from 'prop-types';

import { useCapabilityCheck } from '#globalHooks/useCapabilityCheck';

const RequireCapability = ({ required, children, fallback = null, loading: loadingComponent = null }) => {
	const { hasCapability, isLoading } = useCapabilityCheck(required);

	if (isLoading) return loadingComponent;
	if (hasCapability) return children;
	return fallback;
};

RequireCapability.propTypes = {
	required: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
	children: PropTypes.node,
	fallback: PropTypes.node,
	loading: PropTypes.node,
};

export default RequireCapability;
